import React from 'react';
import './Tag.scss';

class Tag extends React.Component {
  componentDidMount() {
    this.props.tag.on(
      'change',
      () => {
        this.forceUpdate();
      },
      this
    );
  }

  componentWillUnmount() {
    this.props.tag.off(null, null, this);
  }

  render() {
    let tag = this.props.tag;
    const edit = this.props.edit;
    return (
      <label className="label label-success">
        {edit ? (
          <div>
            <span
              className="fa fa-times remove"
              onClick={this.props.onRemove.bind(this, tag)}
            />{' '}
            {tag.get('title')}
          </div>
        ) : (
          <span /*href={'/tags/' + tag.get('id')}*/>{tag.get('title')}</span>
        )}
      </label>
    );
  }
}

export default Tag;
